<template>
  <el-dialog
    destroy-on-close
    v-model="userLoginDialogVisible"
    @closed="ruleFormRef?.resetFields()"
    width="480"
  >
    <div class="user-login">
      <h3>账号密码登录</h3>
      <el-form
        ref="ruleFormRef"
        :model="loginForm"
        :rules="rules"
        label-width="auto"
        label-position="top"
        status-icon
      >
        <el-form-item label="登录账号" prop="username">
          <el-input
            @keydown.enter="submitForm(ruleFormRef)"
            :prefix-icon="User"
            placeholder="登录账号"
            v-model="loginForm.username"
          />
        </el-form-item>

        <el-form-item label="登录密码" prop="password">
          <el-input
            show-password
            :prefix-icon="Lock"
            @keydown.enter="submitForm(ruleFormRef)"
            type="password"
            placeholder="登录密码"
            v-model="loginForm.password"
          />
        </el-form-item>

        <el-form-item label="验证码" class="user-login-captcha" prop="code">
          <el-input
            @keydown.enter="submitForm(ruleFormRef)"
            :prefix-icon="Key"
            placeholder="验证码"
            v-model="loginForm.code"
          />
          <img @click="refreshCaptcha" :src="captchaImg" alt="" />
        </el-form-item>

        <el-form-item>
          <el-button :loading="loading" type="primary" @click="submitForm(ruleFormRef)">
            登 录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script lang="ts" setup>
import { getCaptchaImage, userLogin } from '@/apiFzn'
import type { IUserLoginParams } from '@/apiFzn/types'
import { setToken } from '@/utils/auth'
import { ElMessage, type FormInstance } from 'element-plus'
import { reactive, ref, shallowRef, watch } from 'vue'
import { User, Lock, Key } from '@element-plus/icons-vue'
import { useUserStore } from '@/stores/user'
const userLoginDialogVisible = ref<boolean>(false)

const userStore = useUserStore()

// Form表单实例
const ruleFormRef = shallowRef()

// Form表单参数
const loginForm = reactive<IUserLoginParams>({
  username: 'admin',
  password: 'admin123',
  code: '',
  uuid: '',
})

// Form表单规则校验
const rules = ref({
  username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' },
    { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' },
  ],
  code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
})

const captchaImg = ref('') // 验证码图片

/** 刷新验证码 */
const refreshCaptcha = () => {
  getCaptchaImage().then((res) => {
    captchaImg.value = 'data:image/gif;base64,' + res.img
    loginForm.uuid = res.uuid
  })
}

watch(
  () => userLoginDialogVisible.value,
  () => {
    refreshCaptcha()
  }
)

const loading = ref(false)
/**
 * 表单提交事件
 * @param formEl Form表单实例
 */
const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return
  await formEl.validate((valid) => {
    if (valid) {
      loading.value = true
      userLogin(loginForm)
        .then((res) => {
          setToken(res.token)
          userLoginDialogVisible.value = false
          ElMessage.success('登录成功！')
          userStore.getUserInfoHandler()
        })
        .catch(refreshCaptcha)
        .finally(() => {
          loading.value = false
        })
    }
  })
}

/** 打开弹窗  */
const openModel = () => {
  userLoginDialogVisible.value = true
}

defineExpose({
  openModel,
})
</script>

<style lang="scss" scoped>
.user-login {
  padding: 0 16px;
  > h3 {
    text-align: center;
    font-size: 18px;
    margin-bottom: 21px;
    color: #000;
  }

  &-captcha {
    .el-input {
      width: 65%;
      margin-right: 14px;
    }

    img {
      width: calc(100% - 65% - 14px);
      height: 40px;
      cursor: pointer;
    }
  }

  .el-button {
    margin-top: 12px;
    width: 100%;
    height: 36px;
    font-size: 15px;
  }
}
</style>
